export const setPublicPageToken = ({ key, token }: { key: string; token: string }) => {
  try {
    return localStorage.setItem(key, token);
  } catch (_: unknown) {
    return null;
  }
};
